import type { FunctionalComponent } from 'preact';
import { useStore } from '../store';
import { useCountdown } from '../hooks/useCountdown';
import { formatDate } from '../utils/theme';
import { resolveDisplayOccurrenceIso } from '../lib/eventOccurrenceDates';

/** Event name, description, meta — used in desktop layout left panel */
export const EventInfoBlock: FunctionalComponent = () => {
  const { state } = useStore();
  const { event, widget } = state;
  if (!event || !widget) return null;

  const startForDisplay = resolveDisplayOccurrenceIso(event, state.selectedOccurrenceIso);
  const countdown = useCountdown(startForDisplay);

  return (
    <div class="mw-event-info-block">
      <div class="mw-event-name">{event.name}</div>
      {widget.show_event_description && event.description && (
        <div class="mw-tier-desc">{event.description}</div>
      )}
      <div class="mw-event-meta">
        <span>{formatDate(startForDisplay, event.timezone)}</span>
        {event.location && <span>{event.location.address}</span>}
        {event.kind && (
          <span class="mw-event-kind-chip">{event.kind.replace(/_/g, ' ')}</span>
        )}
      </div>
      {widget.show_countdown && !countdown.isExpired && (
        <div class="mw-countdown">
          <span>⏱</span>
          <span>Starts in {countdown.label}</span>
        </div>
      )}
    </div>
  );
};
